import React, { memo, useEffect } from "react";
import { useDispatch } from "react-redux";
import useMulticotizadorSelector from "./useMulticotizadorSelector";
import { setVehiculoUso, clearVehiculoUso } from "../actions";
import { makeStyles } from "@mui/styles";
import VehiculoUsoSelector from "~business/vehiculoUsoSelector/VehiculoUsoSelector";
import PrimaryTitle from "~styled/primaryTitle/PrimaryTitle";
import { OpcionSeleccionada } from "../types";

const SIN_SELECCION: OpcionSeleccionada = { value: null, label: null };

const useStyles = makeStyles((theme) => ({
  cotizador: {
    flexDirection: "row",
    margin: "auto",
    padding: 20,
    paddingBottom: 100,
    maxWidth: 500,
    width: "100%",
    minHeight: "100vh",
  },
  title: {
    paddingBottom: "16px",
  },
}));

const useReduxSelector = () =>
  useMulticotizadorSelector((state) => ({
    usoSelected: state.usoSelected,
  }));

const UsoStep = memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { usoSelected } = useReduxSelector();

  useEffect(() => {
    dispatch(clearVehiculoUso());
  }, [dispatch]);

  const handleChange = (event: { target: { value: OpcionSeleccionada } }) => {
    dispatch(setVehiculoUso(event.target.value));
  };

  return (
    <>
      <div className={classes.cotizador}>
        <div className={classes.title}>
          <PrimaryTitle
            label="¿Cuál es el uso del vehículo?"
            marginBottom={32}
          />
        </div>
        <VehiculoUsoSelector
          value={usoSelected ?? SIN_SELECCION}
          onChange={handleChange}
        />
      </div>
    </>
  );
});

export default UsoStep;
